import PropTypes from 'prop-types';
import UserProp from '../../../commonComponents/propTypes/userProp';
import FileProp from '../../../commonComponents/propTypes/fileProp';

export const ACTIVITY_TYPE = {
  STATUS: 'status',
  DOCUMENT: 'document',
  NOTE: 'note',
  LOST_REASON: 'lostReason',
};

const propType = {
  type: PropTypes.oneOf(Object.values(ACTIVITY_TYPE)),
  user: PropTypes.shape(UserProp.propType),
  date: PropTypes.number,
  status: PropTypes.string,
  document: PropTypes.shape(FileProp.propType),
  note: PropTypes.string,
};

export default { propType };
